import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

export const PublicRoute = ({ children }) => {
  const { consultant, loading } = useAuth()
  if (loading) return null
  return consultant ? <Navigate to="/submittals" replace /> : children
}

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
}
